import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';

export enum ButtonColor {
  PRIMARY = 'primary',
  WARN = 'warn'
}

export enum ButtonMode {
  PRIMARY = 'primary',
  OUTLINED = 'outlined',
  TEXT = 'text',
  ICON = 'icon'
}

@Component({
  selector: 'vfs-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent extends MatButton {
  modes = ButtonMode;
  colors = ButtonColor;
  @Input() disabled: boolean;
  @Input() color: ButtonColor = ButtonColor.PRIMARY;
  @Input() type: string;
  @Input() mode: ButtonMode = ButtonMode.PRIMARY;
  @Input() secondary: boolean;
  @Input() label: string;
  @Input() small: boolean;
  @Input() icon: string;
  @Input() throttleTime = 500;
  @Input() routerLink: string;

  @Output() buttonClick = new EventEmitter();
  actived = false;

  onButtonClick(evt: Event) {
    if (!this.disabled) {
      this.buttonClick.emit(evt);
    }
  }
}
